import {Injectable} from '@angular/core';
import {environment} from './../../../environments/environment';
import {HttpRequestService} from './../../shared/services/http-request.service';
import {NewPasswordModel, UserModel} from './../../models/user/users.model';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class UsersService {

  private getAllUrl = environment.apiUrl + '/User/GetAll';
  private getAllCommonUrl = environment.apiUrl + '/User/GetAllCommons';
  private getAllBySurveyUrl = environment.apiUrl + '/User/GetAllBySurvey';
  private getAllByClientUrl = environment.apiUrl + '/User/GetAllByClient';
  private isExistingUserUrl = environment.apiUrl + '/User/IsExistingUser';
  private saveUrl = environment.apiUrl + '/User/Save';
  private getUserUrl = environment.apiUrl + '/User/GetUser';
  private addNewUserUrl = environment.apiUrl + '/User/AddNewUser';
  private forgotPasswordUrl = environment.apiUrl + '/User/ForgotPassword';
  private resetPassConfirmUrl = environment.apiUrl + '/User/ResetPasswordConfirmation';
  private setNewPasswordUrl = environment.apiUrl + '/User/SetNewPassword';
  private getClientUrl = environment.apiUrl + '/Client/GetAllClient';

  constructor(private http: HttpRequestService, private httpClient: HttpClient) {
  }

  getAll() {
    return this.http.get(this.getAllUrl, false);
  }

  getAllCommons() {
    return this.http.get(this.getAllCommonUrl, false);
  }

  getAllBySurvey(id) {
    return this.http.get(this.getAllBySurveyUrl + '?surveyId=' + id, false);
  }

  getAllByClient(id) {
    return this.http.get(this.getAllByClientUrl + '?clientId=' + id, false);
  }

  isExistingUser(data: UserModel) {
    return this.http.post(this.isExistingUserUrl, data, false);
  }

  save(data: UserModel) {
    return this.http.post(this.saveUrl, data, true, 'Save complete');
  }

  getUser(userId: number) {
    return this.http.get(this.getUserUrl + '?userID=' + userId, false);
  }

  addNewUser() {
    return this.http.post(this.addNewUserUrl, false);
  }

  forgotPassword(email: string) {
    return this.http.get(this.forgotPasswordUrl + '?email=' + email);
  }

  resetPassConfirmation(hash: string) {
    return this.http.get(this.resetPassConfirmUrl + '?hash=' + hash, true);
  }

  setNewPassword(data: NewPasswordModel) {
    return this.http.put(this.setNewPasswordUrl, data, true);
  }

  getClient() {
    return this.http.get(this.getClientUrl, false);
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/users/users.service.ts